import { Tag } from '@app/components/TagsSelect/ui/Tag';
import { WidthArchiveLabel } from '@app/shared/components';
import type { NClients } from '@app/types';
import { getContrastYIQ } from '@app/utils';

import { PF } from '@pages/Clients/NewClientsList/data/constants';

import type { CheckboxOptionType } from 'antd';

export const getTagsCheckboxOptions = (
  tags:
    | NClients.ModelClientsFilterData['RecordTags']
    | NClients.ModelClientsFilterData['ClientTags']
): CheckboxOptionType<number>[] => {
  return tags.map(({ Id, Name, Color, IconId, IsDeleted }) => ({
    label: (
      <Tag
        label={<WidthArchiveLabel title={Name} isDeleted={IsDeleted} />}
        value={Id}
        color={getContrastYIQ(Color)}
        backgroundColor={Color}
        icon={IconId}
        closable={false}
        className={`${PF}__tag`}
      />
    ),
    value: Id,
    title: Name,
  }));
};
